const apiHost = './';
const publicPath = './';
const imgPublicPath = '../img/';
const env = 'test';

export {
    apiHost,
    publicPath,
    imgPublicPath,
    env
};



// WEBPACK FOOTER //
// ./src/common/js/env.config.js